import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Footer from "./components/Footer";

import Home from "./pages/Home"
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Download from "./pages/Download";
import BenPiper from "./pages/benPiper/BenPiper";

function App() {
  return (
    <BrowserRouter>

      <div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Download" element={<Download />} />
          <Route path="/benjaminpiper" element={<BenPiper />} />
        </Routes>

        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
